import * as React from 'react';
import { fetchGrupoPlanes } from '../../actions/planesActions';
import { connect } from 'react-redux';
import { postAdministracionTiposPublicacion, postTiposPublicacionAsociarGrupoPlanes } from '../../api/axios';
import { setTiposPublicacion, setTiposGrupoPlanes, resetTiposPublicacion } from '../../actions/tiposPublicacionActions';
import { currencyFormat, formatCurrencyToNumber } from '../../helper/publicacionHelper';
import Cleave from 'cleave.js/react';
import { toast } from 'react-toastify';
import { listaIdsGrupoPlanesParaAsociar } from '../../helper/tipoPublicacionHelper';
import GoBackArrow from '../General/GoBackArrow';
import { withNavigation } from '../General/withNavigation';

/*
 * Promoción en tipos de publicación (checkbox + montos). Dejar en false para ocultar.
 * Para volver a mostrar: poner en true.
 */
const PROMOCION_TIPOS_PUBLICACION = true;

class TipoPublicacionesNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            descripcion: "",
            comision: '',
            cantidadCuotas: 0,
            gruposDePlanes: [],
        };
        this.descripcionInputRef = React.createRef();
    };

    componentDidMount() {
        this.busquedaGrupoPlanes({ numeroPagina: 1, cantidadPagina: 10 });
        this.setState({
            descripcion: this.props.setTipoPublicacion.descripcion || '',
            comision: this.props.setTipoPublicacion.comision || '',
            cantidadCuotas: this.props.setTipoPublicacion.cantidadCuotas || 0
         });

        if (this.descripcionInputRef.current) {
            this.descripcionInputRef.current.focus();
        }
    }

    changeCheck = (params) => {
        this.addToPlanes(params);
    }

    clickFila = (params) => {
        this.addToPlanes(params);
    }

    addToPlanes = (params) => {
        let arrayEstado = [];
        arrayEstado = this.state.gruposDePlanes;
        let repetido = arrayEstado.some(x => x == params.idGrupoPlan);

        if (repetido) {
            let index = arrayEstado.findIndex(x => x == params.idGrupoPlan);
            if (index !== undefined) {
                arrayEstado.splice(index, 1);
                this.setState({ gruposDePlanes: arrayEstado });
                document.getElementById("check" + params.idGrupoPlan).checked = false;
            }
        }
        else {
            arrayEstado.push(params.idGrupoPlan);
            this.setState({ gruposDePlanes: arrayEstado });
            document.getElementById("check" + params.idGrupoPlan).checked = true;
        }
    }

    busquedaGrupoPlanes = (request) => {
        let params = request;

        if (!this.props.userType.isAdminMod) {
            params = { ...request, idSeller: this.props.idSeller };
            this.props.fetchGrupoPlanes({ params });
        } else {
            this.props.fetchGrupoPlanes({ params });
        }
    }

    onSubmit = async (event) => {
        event.preventDefault();
        let montoMinimoNumero;
        let montoMaximoNumero;
        let aceptaPromocion;
        if (PROMOCION_TIPOS_PUBLICACION) {
            montoMinimoNumero = this.props.setTipoPublicacion.montoMinimoPromocion != undefined && this.props.setTipoPublicacion.montoMinimoPromocion !== ""
                ? formatCurrencyToNumber(this.props.setTipoPublicacion.montoMinimoPromocion)
                : null;
            montoMaximoNumero = this.props.setTipoPublicacion.montoMaximoPromocion != undefined && this.props.setTipoPublicacion.montoMaximoPromocion !== ""
                ? formatCurrencyToNumber(this.props.setTipoPublicacion.montoMaximoPromocion)
                : null;
            aceptaPromocion = this.props.setTipoPublicacion.aceptaPromocion === true || montoMinimoNumero != null || montoMaximoNumero != null;
        } else {
            montoMinimoNumero = null;
            montoMaximoNumero = null;
            aceptaPromocion = false;
        }

        let data = {
            descripcion: this.props.setTipoPublicacion.descripcion,
            comision: parseFloat(this.props.setTipoPublicacion.comision),
            cantidadCuotas: parseInt(this.props.setTipoPublicacion.cantidadCuotas),
            aceptaPromocion,
            montoMinimo: montoMinimoNumero,
            montoMaximo: montoMaximoNumero
        }
       
        const st = this.props.setTipoPublicacion || {};
        const descripcionOk = String(st.descripcion ?? "").trim() !== "";
        const comisionOk = st.comision !== undefined && st.comision !== "" && !Number.isNaN(parseFloat(st.comision));
        const cuotasRaw = st.cantidadCuotas;
        const cuotasOk = cuotasRaw !== undefined && cuotasRaw !== "" && !Number.isNaN(parseInt(cuotasRaw, 10));

        if (!descripcionOk || !comisionOk || !cuotasOk) {
            if (!descripcionOk) toast.error("Debe agregar una descripción");
            if (!comisionOk) toast.error("Debe agregar una comisión");
            if (!cuotasOk) toast.error("Debe agregar un número de cuotas válido");
            return;
        }

        let postTipo = postAdministracionTiposPublicacion(data);

        postTipo.then(res => {
            toast.success("Tipo publicacion guardada");
            const newId = res.data?.idTipoPublicacion ?? res.data?.IdTipoPublicacion;
            this.asociarGrupoPlanes(newId);
            this.goToTipoPublicaciones();
        }).catch(err => {
            toast.error("No pudo crearse");
            // (err.response.data.errores) ? err.response.data.errores.forEach(error => toast.error(error)) : toast.error("No pudo crearse");
        });

    }

    asociarGrupoPlanes = (id) => {
        const arrayIdsElement = listaIdsGrupoPlanesParaAsociar(
            this.props.tiposGruposPlanes,
            undefined
        );
        let data = {
            idTipoPublicacion: id,
            listaIdsGrupoPlanes: arrayIdsElement
        }

        let asociarGrupoPlanes = postTiposPublicacionAsociarGrupoPlanes(data)
        asociarGrupoPlanes.then(res => {
            toast.success("Se asociaron grupos de planes");
        }).catch(err => {
            // toast.error("No se seleccionaron grupos de planes")
        });
    }

    inputChange = (e) => {
        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;
        
        
        if (e.target.name == "comision" || e.target.name == "cantidadCuotas") {
            let esNumero = valor.match(numbersOnly);
            if (esNumero == null) {
                document.getElementById("comisionId").value = "";
                this.setState({ cambioInputChange: true });
                return;
            }
            if (e.target.value > 100) {
                document.getElementById("comisionId").value = "";
                this.setState({ cambioInputChange: true });
            } else {
                this.setState({ cambioInputChange: true });
                let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor }
                this.props.setTiposPublicacion(estado);
            }
        } else if (PROMOCION_TIPOS_PUBLICACION && e.target.name === "aceptaPromocion") {
            const checked = e.target.checked;
            const estado = checked
                ? { ...this.props.setTipoPublicacion, aceptaPromocion: true }
                : {
                    ...this.props.setTipoPublicacion,
                    aceptaPromocion: false,
                    montoMinimoPromocion: "",
                    montoMaximoPromocion: ""
                };
            this.props.setTiposPublicacion(estado);
        } else if (PROMOCION_TIPOS_PUBLICACION && (e.target.name === "montoMinimoPromocion" || e.target.name === "montoMaximoPromocion")) {
            let formattedValue = currencyFormat(valor);
            let estado = { ...this.props.setTipoPublicacion, aceptaPromocion: true, [e.target.name]: formattedValue };
            this.props.setTiposPublicacion(estado);
        } else {
            let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor }
            this.props.setTiposPublicacion(estado);
        }
    }

    goToBusqueda = () => {
        this.props.navigate("/Tipo/Publicaciones/GrupoPlanes/Busqueda");
    }

    goToTipoPublicaciones = () => {
        this.props.navigate("/Tipo/Publicaciones");
    }

    borrarFila = (idGrupoPlan) => {
        let grupoPlanes = JSON.stringify(this.props.tiposGruposPlanes);
        if (grupoPlanes != "[]") {
            let index = this.props.tiposGruposPlanes.findIndex(x => x.idGrupoPlan == idGrupoPlan);
            this.props.tiposGruposPlanes.splice(index, 1);
            this.props.setTiposGrupoPlanes(this.props.tiposGruposPlanes);
            this.forceUpdate();
        }

    }

    renderGruposSeleccionados = () => {
        const list = this.props.tiposGruposPlanes;
        if (!Array.isArray(list) || list.length === 0) return null;
        return (
            <div className="admin-list-stack mt-3">
                <label className="label-oscura d-block mb-2">Grupos de planes seleccionados</label>
                {list.map((item, idx) => {
                    const isActivo = item.estado === 0;
                    const cardEstado = isActivo ? 'admin-list-card--vigente' : 'admin-list-card--inactivo';
                    return (
                    <div key={item.idGrupoPlan ?? idx} className={`admin-list-card p-3 ${cardEstado}`}>
                        <div className="row g-2 align-items-center">
                            <div className="col-auto">
                                <span className="admin-id-badge">{item.idGrupoPlan}</span>
                            </div>
                            <div className="col text-break">
                                <input
                                    type="text"
                                    readOnly
                                    value={item.descripcion ?? ""}
                                    className="form-control-plaintext admin-list-card__title fw-semibold small mb-0 py-0"
                                    title="Seleccioná el texto para copiar"
                                    style={{ cursor: 'text' }}
                                    aria-label="Nombre del plan"
                                />
                            </div>
                            <div className="col-auto">
                                <span className="admin-metric-pill">
                                    {item.comision}
                                    <i className="fas fa-percent" aria-hidden="true" />
                                </span>
                            </div>
                            <div className="col-auto">
                                <button
                                    type="button"
                                    className="btn btn-link btn-sm text-danger p-0"
                                    onClick={() => this.borrarFila(item.idGrupoPlan)}
                                    aria-label="Quitar grupo"
                                >
                                    <i className="fas fa-trash-alt" />
                                </button>
                            </div>
                        </div>
                    </div>
                )})}
            </div>
        );
    }



    render() {
        let descripcion, comision, cantidadCuotas
        const montoMinimoPromocion = PROMOCION_TIPOS_PUBLICACION ? (this.props.setTipoPublicacion?.montoMinimoPromocion ?? '') : '';
        const montoMaximoPromocion = PROMOCION_TIPOS_PUBLICACION ? (this.props.setTipoPublicacion?.montoMaximoPromocion ?? '') : '';
        const aceptaPromocion = PROMOCION_TIPOS_PUBLICACION && (
            this.props.setTipoPublicacion?.aceptaPromocion === true || montoMinimoPromocion !== '' || montoMaximoPromocion !== '');
        if (!this.state.cambioInputChange) {
            comision = this.state.comisionPredeterminada;
           
        } else {
            descripcion = this.props.setTipoPublicacion.descripcion != undefined ? this.props.setTipoPublicacion.descripcion : this.props.tipoPublicacion.descripcion;
            comision = this.props.setTipoPublicacion.comision != undefined ? this.props.setTipoPublicacion.comision : this.props.tipoPublicacion.comision;
            cantidadCuotas = this.props.setTipoPublicacion.cantidadCuotas
        }
        return (

            <div className="container py-2">
                <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                    <div className="admin-grupo-busqueda-header">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <GoBackArrow />
                                <div>
                                    <h4 className="mb-0 text-body fw-semibold">Crear tipo de publicación</h4>
                                    <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                                        {PROMOCION_TIPOS_PUBLICACION
                                            ? 'Comisión, cuotas, promoción opcional y grupos de planes asociados.'
                                            : 'Comisión, cuotas y grupos de planes asociados.'}
                                    </p>
                                </div>
                            </div>
                            <button type="button" onClick={this.goToBusqueda} className="btn btn-sm background-rojo-megatone text-white">
                                <i className="fa fa-plus-circle me-1" /> Seleccionar grupos
                            </button>
                        </div>
                    </div>

                    <div className="px-4 pb-4 pt-2">
                        <form className="form-horizontal form-material" onSubmit={this.onSubmit}>
                            <div className="form-group">
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label className="label-oscura">Descripción</label>
                                        <input
                                            name="descripcion"
                                            value={this.props.setTipoPublicacion?.descripcion ?? ''}
                                            onChange={this.inputChange}
                                            type="text"
                                            id="firstName"
                                            className="form-control"
                                            ref={this.descripcionInputRef}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <small className="font-14 applyFont"><i className="fas fa-percent" /></small>
                                        <label className="label-oscura">&ensp;Comisión</label>
                                        <Cleave
                                            className="form-control"
                                            id="comisionId"
                                            name="comision"
                                            value={this.props.setTipoPublicacion?.comision ?? ''}
                                            onChange={this.inputChange}
                                            options={{ blocks: [5], numericOnly: false }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="label-oscura">N° Cuotas</label>
                                        <Cleave
                                            name="cantidadCuotas"
                                            value={this.props.setTipoPublicacion?.cantidadCuotas ?? ''}
                                            onChange={this.inputChange}
                                            id="cuotasId"
                                            className="form-control"
                                            options={{ blocks: [3], numericOnly: true }}
                                        />
                                    </div>
                                </div>

                                {PROMOCION_TIPOS_PUBLICACION && (
                                <div className="row g-3 mt-1">
                                    <div className="col-12 mb-2">
                                        <div className="form-check form-switch d-flex align-items-center gap-2">
                                            <label className="form-check-label label-oscura mb-0" htmlFor="habilitarPromocionNew">
                                                Habilitar promoción
                                            </label>
                                            <input
                                                className="form-check-input m-0"
                                                type="checkbox"
                                                id="habilitarPromocionNew"
                                                name="aceptaPromocion"
                                                checked={aceptaPromocion}
                                                onChange={this.inputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="label-oscura">Monto mínimo promoción</label>
                                        <input
                                            name="montoMinimoPromocion"
                                            value={montoMinimoPromocion}
                                            onChange={this.inputChange}
                                            type="text"
                                            className="form-control"
                                            maxLength="12"
                                            disabled={!aceptaPromocion}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="label-oscura">Monto máximo promoción</label>
                                        <input
                                            name="montoMaximoPromocion"
                                            value={montoMaximoPromocion}
                                            onChange={this.inputChange}
                                            type="text"
                                            className="form-control"
                                            maxLength="12"
                                            disabled={!aceptaPromocion}
                                        />
                                    </div>
                                </div>
                                )}
                            </div>

                            {this.renderGruposSeleccionados()}

                            <div className="d-flex justify-content-center flex-wrap gap-2 mt-4 pt-3 border-top">
                                <button type="submit" className="btn btn-sm btn-green px-4">Guardar</button>
                                <button type="button" onClick={this.goToTipoPublicaciones} className="btn btn-sm btn-light">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

}


const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    grupoPlanes: state.planes.grupoPlanes.elementos,
    setTipoPublicacion: state.tiposPublicacion.setTiposPublicacion,
    tiposGruposPlanes: state.tiposPublicacion.tiposGruposPlanes,
    resetTiposPublicacion: state.tipoPublicacion
});
export default withNavigation(connect(mapStateToProps, {
    fetchGrupoPlanes,
    setTiposPublicacion,
    setTiposGrupoPlanes,
    resetTiposPublicacion
})(TipoPublicacionesNew));